import { format } from 'date-fns';

// will return the date with time
export const getTimeStampFormat = (value : Date) => format(new Date(value), 'MMM dd, yyyy HH:mm:ss');

// will return the date with time
export const getTimeStampYearFirst = (value : Date) => format(new Date(value), 'yyyy-MM-dd HH:mm:ss');

// will return only date
export const getDateFormat = (value : Date) => format(new Date(value), 'dd MMM, yyyy');

// will return the date with time and meridiem
export const getTimeStampFormatWithMeridiem = (value : Date) => format(new Date(value), 'dd MMM, yyyy hh:mm a');

// will return the time and meridian of a date
export const getTimeStampFromDate = (value : Date) => format(new Date(value), 'hh:mm a');

// will return only date
export const getDayMonth = (value : Date) => format(new Date(value), 'dd MMM');

// will return only date in reverse Format
export const getDateReverseFormat = (value : Date) => format(new Date(value), 'yyyy-MM-dd');

// will return Date with start time
// Use this function wherever we are initialising dates
export const getDateStart = () => new Date(new Date().setHours(0, 0, 0, 0));

// will return Date with start time
export const getStartOfDay = (value: Date) => new Date(value.setHours(0, 0, 0, 0));

// will return Date with end time
export const getEndOfDay = (value: Date) => new Date(value.setHours(23, 59, 59, 999));
